function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.entries.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.flags.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.array.is-array.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.symbol.iterator.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.from.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.symbol.to-primitive.js";
import "core-js/modules/es.date.to-primitive.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import React from 'react';
import { groupBy } from 'lodash';
import { Accordion, Flex } from '@applyboard/crystal-ui';
import { useEventTracker } from '@applyboard/ui-utils';
import { strings } from "./strings";
import { shouldShowDiscrepancyInfo } from "./utils";
import { ResultMessage } from "./ResultMessage";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
var accordionIntentOrder = ['negative', 'warning', 'positive'];
export function VerificationResults(props) {
  var _useEventTracker = useEventTracker(),
    trackEvent = _useEventTracker.trackEvent;
  var _React$useState = React.useState([]),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    accordionState = _React$useState2[0],
    setAccordionState = _React$useState2[1];
  var source = {
    applicationId: props.applicationId,
    requirementId: props.requirement.id,
    attachmentId: props.attachment.id,
    requirementCategory: props.requirement.requirementCategory,
    requirementTemplateId: props.requirement.requirementTemplateId
  };
  var verificationResults = formatResults({
    results: props.attachment.automatedVerificationResults,
    discrepancy: props.documentDiscrepancyMapping[props.attachment.id],
    flags: {
      enablePlagiarismResults: props.plagiarismFeatureFlagEnabled
    } // TODO: Replace with result of useFeatureFlags
  });
  var messagesByIntent = groupBy(verificationResults, 'intent');
  var intentsWithMessages = Object.entries(messagesByIntent).sort(function (a, b) {
    return accordionIntentOrder.indexOf(a[0]) - accordionIntentOrder.indexOf(b[0]);
  });
  return _jsx(Accordion, {
    allowMultipleOpen: true,
    onChange: function onChange(value) {
      var openItems = typeof value === 'string' ? [value] : value;
      trackEvent(createAccordionEvent(accordionState, openItems, props));
      setAccordionState(openItems);
    },
    children: intentsWithMessages.map(function (_ref, index) {
      var _ref2 = _slicedToArray(_ref, 2),
        intent = _ref2[0],
        messages = _ref2[1];
      // disable disable & autoOpen management temporarily
      // const isPrimaryNoticesList = intent === 'negative' || components.length === 1;

      return _jsx(Accordion.Item, {
        // autoOpen={isPrimaryNoticesList}
        // disabled={isPrimaryNoticesList}
        id: intent,
        title: "".concat(strings.intentTitles[intent], " (").concat(messages.length, ")"),
        children: _jsx("div", {
          style: {
            maxHeight: '200px',
            overflowY: 'auto'
          },
          children: _jsx(Flex, {
            direction: "column",
            gap: 4,
            children: messages.map(function (m) {
              return _jsx(ResultMessage, {
                text: m.text,
                rule: m.rule,
                intent: m.intent,
                result: m.result,
                source: source
              }, m.rule);
            })
          })
        })
      }, index);
    })
  });
}
function createAccordionEvent(previouslyOpen, currentlyOpen, accordionProps) {
  var newlyClosed = previouslyOpen.filter(function (v) {
    return !currentlyOpen.includes(v);
  });
  var newlyOpened = currentlyOpen.filter(function (v) {
    return !previouslyOpen.includes(v);
  });
  var operation = 'changed';
  var changed = currentlyOpen;
  if (newlyClosed.length && !newlyOpened.length) {
    operation = 'closed';
    changed = newlyClosed;
  } else if (newlyOpened.length && !newlyClosed.length) {
    operation = 'opened';
    changed = newlyOpened;
  }
  return {
    event: "Single Application - Applicant Requirements - Preview mode message accordion ".concat(operation),
    data: {
      requirementId: accordionProps.requirement.id,
      requirementTemplateId: accordionProps.requirement.requirementTemplateId,
      item: changed.map(function (id) {
        return strings.intentTitles[id];
      }).join(',')
    }
  };
}
function formatResults(_ref3) {
  var results = _ref3.results,
    discrepancy = _ref3.discrepancy,
    flags = _ref3.flags;
  var messages = [];
  if (shouldShowDiscrepancyInfo(discrepancy)) {
    messages.push({
      intent: 'warning',
      rule: 'document_mismatch',
      text: strings.verificationWarningMessages['document_mismatch']
    });
  }
  results.forEach(function (result) {
    if (result.verificationType === 'plagiarism' && !flags.enablePlagiarismResults) return;
    if (result.outcome) {
      messages.push.apply(messages, _toConsumableArray(getMessagesFromOutcome(result.outcome).map(function (r) {
        return _objectSpread(_objectSpread({}, r), {
          result: result
        });
      })));
    } else {
      messages.push.apply(messages, _toConsumableArray(getMessagesFromResult(result).map(function (r) {
        return _objectSpread(_objectSpread({}, r), {
          result: result
        });
      })));
    }
  });
  return removeExclusiveResults(messages);
}
function getMessagesFromOutcome(verificationOutcome) {
  var messages = [];
  verificationOutcome === null || verificationOutcome === void 0 ? void 0 : verificationOutcome.forEach(function (outcome) {
    if (!outcome.reason) return;
    switch (outcome.result) {
      case 'passed':
        messages.push({
          intent: 'positive',
          text: outcome.reason,
          rule: outcome.validationRule
        });
        break;
      case 'failed':
      case 'manual_check_required':
        messages.push({
          intent: 'negative',
          text: outcome.reason,
          rule: outcome.validationRule
        });
        break;
      default:
        messages.push({
          intent: 'warning',
          text: outcome.reason,
          rule: outcome.validationRule
        });
    }
  });
  return messages;
}
function getMessagesFromResult(verificationResult) {
  var EXCLUDED_RESULT_CODES = ['document_mismatch', 'check_complete'];
  var NEGATIVE_RESULT_CODES = ['student_ineligible', 'check_failure', 'check_timeout'];
  var POSITIVE_RESULT_CODES = ['successfully_passed', 'ielts_extraction_complete'];
  if (EXCLUDED_RESULT_CODES.includes(verificationResult.resultCode)) {
    return [];
  }
  var warningMessage = strings.verificationWarningMessages[verificationResult.resultCode];
  if (!warningMessage) {
    if (NEGATIVE_RESULT_CODES.includes(verificationResult.resultCode) && verificationResult.verificationType === 'plagiarism') {
      warningMessage = strings.plagiarismResultMessages.FAILED_TO_CALL_SERVICE;
    } else {
      return [];
    }
  }
  var intent = POSITIVE_RESULT_CODES.includes(verificationResult.resultCode) ? 'positive' : NEGATIVE_RESULT_CODES.includes(verificationResult.resultCode) ? 'negative' : 'warning';
  return [{
    intent: intent,
    text: warningMessage,
    rule: verificationResult.verificationType
  }];
}
function removeExclusiveResults(messages) {
  var remaining = messages.slice(0);
  var exclusiveResults = [['personal_information_mismatch', 'document_mismatch'], ['exam_information_mismatch', 'document_mismatch']];
  exclusiveResults.forEach(function (er) {
    var ruleIndexes = messages.map(function (m) {
      return m.rule ? er.indexOf(m.rule) : -1;
    });
    ruleIndexes = ruleIndexes.filter(function (i) {
      return i > -1;
    });
    if (ruleIndexes.length) {
      var min_rule = Math.min.apply(Math, _toConsumableArray(ruleIndexes));
      remaining = remaining.filter(function (o) {
        return o.rule ? er.indexOf(o.rule) <= min_rule : false;
      });
    }
  });
  return remaining;
}